"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _r10SourceLibrary = require("r10-source-library");
var _react = _interopRequireWildcard(require("react"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const ToggleButton = _ref => {
  let {
    defaultValue,
    id,
    onChange
  } = _ref;
  const [isActive, setIsActive] = (0, _react.useState)(defaultValue);
  const handleChange = (0, _react.useCallback)(event => {
    const value = event.target.checked;
    setIsActive(value);
    onChange(value);
  }, [onChange, setIsActive]);
  return /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Toggle, {
    dataAttributes: {
      'data-testid': id,
      'aria-label': 'toggle'
    },
    showIcons: false,
    id: id,
    isActive: isActive,
    onChange: handleChange,
    value: isActive ? 'true' : 'false',
    name: id
  });
};
var _default = ToggleButton;
exports.default = _default;